/** Mensagens padronizadas PHONE-REQUIRED-01 */
export const PHONE_REQUIRED_EMPTY_MESSAGE = "Informe o telefone.";
export const PHONE_REQUIRED_INVALID_MESSAGE =
  "Informe um telefone válido com DDD.";

export function validateRequiredPhone(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return PHONE_REQUIRED_EMPTY_MESSAGE;
  }
  return null;
}

export function validatePhoneFormat(value: string): string | null {
  const emptyError = validateRequiredPhone(value);
  if (emptyError) return emptyError;

  const digits = value.replace(/\D/g, "");
  if (digits.length < 10 || digits.length > 11) {
    return PHONE_REQUIRED_INVALID_MESSAGE;
  }

  return null;
}
